import { render, staticRenderFns } from "./nutrition.vue?vue&type=template&id=3cc937a0&scoped=true&"
import script from "./nutrition.vue?vue&type=script&lang=js&"
export * from "./nutrition.vue?vue&type=script&lang=js&"
import style0 from "./nutrition.vue?vue&type=style&index=0&id=3cc937a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc937a0",
  null
  
)

export default component.exports